<template>
  <div class="error">
    <img src="@/assets/error-img-404.png" alt="">
    <p>404</p>
    <router-link class="goHome" to="/">返回首页</router-link>
  </div>
</template>

<script>
export default {
  name: 'Error404'
}
</script>

<style lang="stylus" scoped>
.error
  width 100vw
  background #fff
  min-height 500px
  display flex
  justify-content center
  align-items center
  flex-direction column
  height calc(100vh - 120px)
  font-family '微软雅黑'
  p
    font-size 60px
    color #016cfa
    font-weight bold
    padding 10px 0
  .goHome
    color #fff
    width 200px
    height 40px
    line-height 40px
    display block
    background #016cfa
    font-size 15px
    border-radius 4px
    text-align center
    margin-bottom 50px
</style>
